import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { useState, useRef, useEffect, useContext } from "react";
import { getIpPublic } from "../../utils/getIpPublic";
import Put from "../../api/Put";
import { GET_CONSENTIMIENTO_INFORMADO_CONSULTORIO, PARTNER_GET_ACTIVE_SIN_TOKEN, TIPO_DOCUMENTO_PACIENTE_COLOMBIA, UPDATE_APPOINTMENT_SIN_TOKEN } from "../../api/Routes";
import SignatureCanvas from "react-signature-canvas";
import Post from "../../api/Post";
import { authContext } from "../../context/AuthContext";
import SimpleLoad from "../../loader/SimpleLoad";
import Get from "../../api/Get";

export default function ComponentModalConsentimiento({open, setOpen, setApproveConsentimiento, cita}){
    //console.log(cita)
    const [isSubmiting, setIsSubmiting] = useState(false)
    const {auth} = useContext(authContext)  
    const [content, setContent] = useState('')
    const [checkedTerms, setCheckedTerms] = useState(false)
    const [openConfirmacionDeclinar, setOpenConfirmacionDeclinar] = useState(false)
    const [error, setError] = useState({
        firma: {
            error: false,
            text: ''
        },
        identityDocumentType: {
            error: false,
            text: ''
        },
        documentNumber: {
            error: false,
            text: ''
        },
        fullName: {
            error: false,
            text: ''
        },
        patientRelationship: {
            error: false,
            text: ''
        }
    });
    const [aceptacionAcudiente, setAceptacionAcudiente] = useState(false)
    const [tipoDocumentoOpt, setTipoDocumentoOpt] = useState([])
    const [identityDocumentType, setIdentityDocumentType] = useState('')
    const [documentNumber, setDocumentNumber] = useState('')
    const [fullName, setFullName] = useState('')
    const [tipoPacientes, setTipoPacientes] = useState([])
    const [patientRelationship, setPatientRelationship] = useState('')
    const sigCanvas = useRef({});

    const fetchTipoDocumentoApi = async () => {
        try {
            const response = await Get({url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA, noToken: true});
            setTipoDocumentoOpt(response.data)            
        } catch (error) {
            setTipoDocumentoOpt([])
        }        
    }
    const fetchTipoPacienteApi = async () => {
        try {
            const response = await Get({url: `${PARTNER_GET_ACTIVE_SIN_TOKEN}/${cita.account.id}`, noToken:  true})
            setTipoPacientes(response.data.data.response)
        } catch (error) {
            setTipoPacientes([])
        }        
    }
    useEffect(() => {
        fetchTipoDocumentoApi()
        fetchTipoPacienteApi();
    }, [])

    useEffect(() => {
        let d = {
            account: {
                id: cita.account.id
              },
            documentNumber: cita.patientDTO?.documentNumber,
            identityDocumentType: {
            id: '',
            name: '',
            code: cita.patientDTO?.identityDocumentType?.code
            },
            lastName: cita.patientDTO.lastName,
            expediente: cita.scheduleDTO.name_doctor,
            name: `${cita.patientDTO.name} ${cita.patientDTO.middleName}` ,
            seccondSurname: cita.patientDTO.seccondSurname,
            nombreCompleto:``,
            nationality: cita.speciality.name       
        }
        async function getConsentimiento(){
            try {                
                const response = await Post({url: `${GET_CONSENTIMIENTO_INFORMADO_CONSULTORIO}`, data: d, header: true, access_token:auth.data.access_token})
                //console.log(response)
                if(response.data.state){
                    setContent(response.data.data.data)
                }                                
            } catch (error) {
                
            }     
        }
        getConsentimiento();
    },[])

    const handleClose = () => setOpen(false)
    const handleCloseDeclinar = () => {
        setOpenConfirmacionDeclinar(false)
        setOpen(true)
    }
    const clear = () => sigCanvas.current.clear();

    const handleDeclinarAppointment = () =>{
        setIsSubmiting(true)
        getIpPublic()
        .then(response=>{
            const legalW = cita.legalWarnings.length >  0 ? cita.legalWarnings[0] : null
            let data = {
                id: cita.id,
                legalWarnings: [{
                    id: legalW ? legalW.id : null,
                    acceptPatient: "declined",
                    ipAddress: response,
                    legalWarningType: "InformedConsent",
                    dataRecord: content,
                }]
            }
            //console.log(data)
            Put({url: UPDATE_APPOINTMENT_SIN_TOKEN, data: data, header: false})
            .then(response=>{
                window.location.reload();
                setIsSubmiting(false)
                //setLegalWarning(response.data.data.legalWarnings[0])
            })
            .catch(error=>{
                setIsSubmiting(false)
                // setShowModalError(true)
                // if(error.response){
                //     setErrorServer(error.response)
                // }
            })
        })
        .catch(error=>{
            const legalW = cita.legalWarnings.length >  0 ? cita.legalWarnings[0] : null
            let data = {
                id: cita.id,
                legalWarnings: [{
                    id: legalW ? legalW.id : null,
                    acceptPatient: "declined",
                    legalWarningType: "InformedConsent",
                    dataRecord: content,
                }]
            }
            Put({url: UPDATE_APPOINTMENT_SIN_TOKEN, data: data, header: false})
            .then(response=>{
                window.location.reload();
                setIsSubmiting(false)
                //setLegalWarning(response.data.data.legalWarnings[0])
            })
            .catch(error=>{
                setIsSubmiting(false)
                // setShowModalError(true)
                // if(error.response){
                //     setErrorServer(error.response)
                // }
            })
        })
    }
    const [allowDoAppt, setAllowDoAppt] = useState(true);
    const handleAcceptar = () =>{
        //checamos si tiene la firma
        let doAppt = allowDoAppt;
        if(sigCanvas.current.isEmpty() || aceptacionAcudiente){
            const errorCopy = {...error}
            if(sigCanvas.current.isEmpty()){
                errorCopy.firma.error = true;
                errorCopy.firma.text = 'Firma requerida'
                doAppt = false;
            }else{
                errorCopy.firma.error = false;
                errorCopy.firma.text = ''
            }
            if(fullName === ''){
                errorCopy.fullName.error = true;
                errorCopy.fullName.text = 'Campo requerido';
                doAppt = false;
            }else{
                errorCopy.fullName.error = false;
                errorCopy.fullName.text = ''
            }
            if(documentNumber === ''){
                errorCopy.documentNumber.error = true;
                errorCopy.documentNumber.text = 'Campo requerido';
                doAppt = false;
            }else{
                errorCopy.documentNumber.error = false;
                errorCopy.documentNumber.text = ''
            }
            if(patientRelationship === ''){
                errorCopy.patientRelationship.error = true;
                errorCopy.patientRelationship.text = 'Campo requerido';
                doAppt = false;
            }else{
                errorCopy.patientRelationship.error = false;
                errorCopy.patientRelationship.text = ''
            }
            if(identityDocumentType === ''){
                errorCopy.identityDocumentType.error = true;
                errorCopy.identityDocumentType.text = 'Campo requerido';
                doAppt = false;
            }else{
                errorCopy.identityDocumentType.error = false;
                errorCopy.identityDocumentType.text = ''
            }
            setError(errorCopy)
        }
        
        if(doAppt){
            setIsSubmiting(true)
            setError(err => ({
                ...err,
                firma: {
                    error: false,
                    text: ''
                }
               }))
            const firma = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png")
            const base64result = firma.split(',')[1];
            getIpPublic()
            .then(response=>{
                const legalW = cita.legalWarnings.length >  0 ? cita.legalWarnings[0] : null
                let data = {
                    id: cita.id,
                    legalWarnings: [{
                        id: legalW ? legalW.id : null,
                        acceptPatient: "approved",
                        ipAddress: response,
                        legalWarningType: "InformedConsent",
                        dataRecord: content,
                        url_photo: base64result,
                        legalAgent: aceptacionAcudiente ? {
                            fullName: fullName,
                            documentNumber: documentNumber,
                            identityDocumentType: {
                                id: identityDocumentType
                            },
                            "patientRelationship": {
                                id: patientRelationship
                            }
                        }: null
                    }]
                }
                //console.log(data)
                Put({url: UPDATE_APPOINTMENT_SIN_TOKEN, data: data, header: false})
                .then(response=>{
                    setApproveConsentimiento(true)
                    setIsSubmiting(false)
                    setOpen(false)
                    //setLegalWarning(response.data.data.legalWarnings[0])                    
                })
                .catch(error=>{
                    setIsSubmiting(false)
                    // setShowModalError(true)
                    // if(error.response){
                    //     setErrorServer(error.response)
                    // }
                })
            })
            .catch(error=>{
                const legalW = cita.legalWarnings.length >  0 ? cita.legalWarnings[0] : null
                let data = {
                    id: cita.id,
                    legalWarnings: [{
                        id: legalW ? legalW.id : null,
                        acceptPatient: "approved",
                        legalWarningType: "InformedConsent",
                        dataRecord: content,
                        url_photo: base64result,
                        legalAgent: aceptacionAcudiente ? {
                            fullName: fullName,
                            documentNumber: documentNumber,
                            identityDocumentType: {
                                id: identityDocumentType
                            },
                            "patientRelationship": {
                                id: patientRelationship
                            }
                        }: null
                    }]
                }
                //console.log(data)
                Put({url: UPDATE_APPOINTMENT_SIN_TOKEN, data: data, header: false})
                .then(response=>{
                    setApproveConsentimiento(true)
                    setIsSubmiting(false)
                    setOpen(false)
                    //setLegalWarning(response.data.data.legalWarnings[0])
                })
                .catch(error=>{
                    setIsSubmiting(false)
                    // setShowModalError(true)
                    // if(error.response){
                    //     setErrorServer(error.response)
                    // }
                })
            })
        }
    }

    const getTipoDocumento = (value) =>{
        let arr = tipoDocumentoOpt.filter(el=>el.code==="AS" || el.code==="MS").map(e=>(e.id))
        return arr.includes(parseInt(value))
    }
    const [hasLength, setHasLength] = useState(10)
    const getLengthDN = (code) =>{
        switch(code.toUpperCase()){            
            case 'CE':
                return 12
            case 'CD':
            case 'PA':
            case 'SC':
                return 16
            case 'PE':
                return 15
            case 'RC':
            case 'TI':
                return 11
            case 'CN':
                return 9
            case 'MS':
                return 12
            default:
                return 10;
        }
    }

    const checkValidationDocument = (value) => {
        if(getTipoDocumento(identityDocumentType)){
            setError(err=>({
                ...err,
                documentNumber: {
                    error: true,
                    text: 'Campo requerido'
                }
            }))
            setAllowDoAppt(false)
        }else{
            if(value === ''){
                setError(err=>({
                    ...err,
                    documentNumber: {
                        error: true,
                        text: 'Campo requerido'
                    }
                }))
                setAllowDoAppt(false)
            }
            if(value.length < 5){
                setError(err=>({
                    ...err,
                    documentNumber: {
                        error: true,
                        text: 'Debe tener una longitud mínima de 5 caracteres'
                    }
                }))
                setAllowDoAppt(false)
            }else if(value.length > hasLength){
                setError(err=>({
                    ...err,
                    documentNumber: {
                        error: true,
                        text: `Debe tener una longitud máxima de ${hasLength} caracteres`
                    }
                }))
                setAllowDoAppt(false)
            }else{
                setError(err=>({
                    ...err,
                    documentNumber: {
                        error: false,
                        text: ''
                    }
                }))
                setAllowDoAppt(true)
            }
        }
    }

    return (
        <>
            <Modal show={open} onHide={handleClose} backdrop="static" keyboard={false} size="xl">
                <Modal.Body className="position-relative overflow-hidden">
                    {isSubmiting && <SimpleLoad />}
                    <h5 className="text-uppercase">CONSENTIMIENTO INFORMADO PARA EL SERVICIO DE ATENCIÓN DOMICILIARIA</h5>
                    <hr />
                    <p dangerouslySetInnerHTML={{ __html: content}}></p>
                    <Row>
                        <Col xs="12" md={{span: 6, offset: 3}}>
                            <div className="border">
                                <SignatureCanvas
                                    penColor='blue'
                                    ref={sigCanvas}
                                    canvasProps={{width: 500, height: 200, border: '1px solid #000'}} 
                                />
                                {error.firma.error && <span className="text-danger">{error.firma.text}</span>}
                            </div>
                            <div className="w-100 text-right">
                                <Button 
                                    variant="outline-secondary" 
                                    onClick={clear}
                                    size="sm"
                                    >Limpiar
                                </Button>
                            </div>
                            
                        </Col>
                    </Row>
                    <div>
                        <Form.Check 
                            className="color-354052 font-size-08rem font-weight-bold-600"
                            type="checkbox"
                            label="Aceptación de consentimiento por acudiente"
                            checked={aceptacionAcudiente}
                            onChange={e=>{
                                setAceptacionAcudiente(e.target.checked)
                                if(!e.target.checked){
                                    setIdentityDocumentType('')
                                    setDocumentNumber('')
                                    setPatientRelationship('')
                                    setFullName('')
                                }
                            }}
                        />
                    </div>
                    {
                        aceptacionAcudiente &&
                        <Row>
                            <Col xs="12" md="6">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">Tipo de documento <span className="text-danger">*</span></Form.Label>
                                    <Form.Control 
                                        as="select"
                                        className={`input-form ${error.identityDocumentType.error && 'error'}`}
                                        value={identityDocumentType}
                                        onChange={e=>{
                                            setIdentityDocumentType(e.target.value)
                                            let aux = tipoDocumentoOpt.filter(el=>el.id===parseInt(e.target.value))[0]
                                            setHasLength(getLengthDN(aux.code))                                      
                                        }}
                                    >
                                        <option value="">Seleccionar</option>
                                        {
                                            tipoDocumentoOpt.map((item,i)=>(
                                                <option value={item.id} key={i}>{`${item.code} : ${item.name}`}</option>
                                            ))
                                        }                                                
                                    </Form.Control>                                                                              
                                    { error.identityDocumentType.error && <div className="invalid-feedback d-block">{error.identityDocumentType.text}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="6">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">Documento de identidad <span className="text-danger">*</span></Form.Label>
                                    <Form.Control 
                                        type="text"
                                        className={`input-form ${error.documentNumber.error && 'error'}`}
                                        name={documentNumber}
                                        onChange={e=>setDocumentNumber(e.target.value)}
                                        onBlur={e=>checkValidationDocument(e.target.value)}
                                    />
                                    { error.documentNumber.error && <div className="invalid-feedback d-block">{error.documentNumber.text}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="6">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">Nombre completo <span className="text-danger">*</span></Form.Label>
                                    <Form.Control 
                                        type="text"
                                        className={`input-form text-uppercase ${error.fullName.error && 'error'}`}
                                        name={fullName}
                                        onChange={e=>setFullName(e.target.value.toUpperCase())}
                                    />
                                    { error.fullName.error && <div className="invalid-feedback d-block">{error.fullName.text}</div> }
                                </Form.Group>
                            </Col>
                            <Col xs="12" md="6">
                                <Form.Group>
                                    <Form.Label className="font-weight-bold-600 text-secondary">Parentesco <span className="text-danger">*</span></Form.Label>
                                    <Form.Control 
                                        as="select"
                                        className={`input-form ${error.patientRelationship.error && 'error'}`}
                                        name={patientRelationship}
                                        onChange={e=>setPatientRelationship(e.target.value)}
                                    >
                                    <option value="">Seleccionar</option>
                                    {
                                        tipoPacientes.map((item,i)=>(
                                            <option key={i} value={item.id}>{item.name}</option>
                                        ))
                                    }
                                </Form.Control>
                                { error.patientRelationship.error && <div className="invalid-feedback d-block">{error.patientRelationship.text}</div> }
                                </Form.Group>
                            </Col>
                        </Row>
                    }

                    <div className="mt-3">
                        <Form.Group className="text-center">
                            <Form.Check type="checkbox" label="Acepto" className="checked-terms" onChange={e=>setCheckedTerms(e.target.checked)} />
                        </Form.Group>
                    </div>
                    <Row className="text-center">
                        <Col>
                            <Button variant="link" className="text-danger font-weight-bold" onClick={() => {
                                setOpen(false)
                                setOpenConfirmacionDeclinar(true)
                            }}>Declinar</Button>{' '}
                            <Button 
                                variant="outline-success" 
                                className="ok-buttom" 
                                onClick={handleAcceptar}
                                disabled={!checkedTerms}
                                >Aceptar
                            </Button>
                        </Col>
                    </Row> 
                </Modal.Body>
            </Modal>

            <Modal show={openConfirmacionDeclinar} onHide={handleCloseDeclinar} backdrop="static" keyboard={false} size="lg">
                {isSubmiting && <SimpleLoad />}
                <Modal.Body className="position-relative overflow-hidden">
                    <h5 className="text-center mb-5">¿Usted está seguro desea rechazar su consentimiento informado?  Al seleccionar Si, no se podrá continuar con su atención médica?</h5>                    
                    <Row className="text-center">
                        <Col>
                            <Button 
                                variant="secondary" 
                                onClick={() => {
                                    setOpenConfirmacionDeclinar(false)
                                    setOpen(true)
                                }}
                            >No
                            </Button>{' '}
                            <Button 
                                variant="success" 
                                onClick={handleDeclinarAppointment}
                            >Si
                            </Button>
                        </Col>
                    </Row> 
                </Modal.Body>
            </Modal>
        </>
        
    )
}